// Generic imports
import React, { useState, useRef, useEffect } from "react"
import { navigate } from "gatsby"
import { connect } from "react-redux"
import { toast } from "react-toastify"
import loadable from "@loadable/component"

// Other components imports
import Button from "components/Button"
import ImageFile from "components/Reusable/Input/imagefile"
import Select from "components/Reusable/Input/select"
import SelectKota from "components/Reusable/Input/select-kota"
import JadwalMaker from "./jadwal-maker"
import InvitePengajar from "./invite-pengajar"
import Modal from "components/Reusable/Modal"
import Alert from "components/Reusable/Alert"
import MustLoggedInWrapper from "components/Reusable/MustLoggedInWrapper"
import { ClassStyles } from "./old-class-style"
import { StyledForm } from "components/CreateClass/style"

// Redux imports
import * as sessionSelectors from "rdx/slices/session/selectors"

// Utils imports
import { createClass, updateClass, getClassUsingId } from "services/kelas"
import { dummyKelas } from "data/dummy/dummykelas"
import { typeKelasList } from "./data"

const InputDraft = loadable(() => import("components/Reusable/Input/draft"))

const mapStateToProps = state => ({
  user: sessionSelectors.getUser(state),
})

const mapDispatchToProps = {}

const withConnect = connect(mapStateToProps, mapDispatchToProps)

const CreateClass = props => {
  const { user, isEdit } = props
  const form = useRef(null)
  const [loading, setLoading] = useState(false)
  const [isSuccess, setSuccess] = useState(false)
  const [smallnav, setSmallnav] = useState("tentang-kelas")
  const [kelas, setKelas] = useState(dummyKelas)

  useEffect(() => {
    if (props.kelas?.slug) {
      setKelas(props.kelas)
    }
  }, [props.kelas])

  const updateKelas = () => {
    getClassUsingId(kelas.id)
      .then(resp => {
        if (resp.data) {
          setKelas(resp.data)
        } else {
          throw new Error()
        }
      })
      .catch(() => {
        navigate("/")
      })
  }

  const controlledKelas = attr => e => {
    const newKelas = { ...kelas }
    newKelas[attr] = e.target.value
    setKelas(newKelas)
  }

  const submit = e => {
    e.preventDefault()
    setLoading(true)
    const data = new FormData(form.current)
    if (!data.get("logo") || data.get("logo").name === "") {
      data.delete("logo")
    }
    if (!data.get("poster") || data.get("poster").name === "") {
      data.delete("poster")
    }
    if (!/^[a-z0-9-]+$/.test(data.get("slug"))) {
      toast.error("Invalid slug. Only a-z, 0-9, and - are allowed")
      setLoading(false)
      return
    }
    if (data.get("slug").length < 5) {
      toast.error("Slug must be 5 characters or more")
      setLoading(false)
      return
    }

    if (data.get("syllabus_link")) {
      if (
        !data.get("syllabus_link").startsWith("http://") &&
        !data.get("syllabus_link").startsWith("https://")
      ) {
        toast.error("Link must starts with http:// or https://")
        setLoading(false)
        return
      }
    }

    if (isEdit) {
      data.set("id", kelas.id)
      updateClass(data)
        .then(() => {
          setSuccess(true)
        })
        .catch(err => {
          let errMsg = ""
          for (const prop in err.response.data) {
            const errData = err.response.data[prop]
            if (typeof errData === "string") {
              errMsg += errData
            } else {
              errMsg += errData?.join(" ")
            }
          }
          if (errMsg === "") {
            errMsg = "An error occured. Please try again later"
          }
          toast.error(errMsg)
        })
        .finally(() => {
          setLoading(false)
        })
    } else {
      createClass(data)
        .then(resp => {
          setSuccess(true)
          navigate(`/edit-kelas/${resp.data.slug}/`)
        })
        .catch(err => {
          let errMsg = ""
          for (const prop in err.response.data) {
            const errData = err.response.data[prop]
            if (typeof errData === "string") {
              errMsg += errData
            } else {
              errMsg += errData?.join(" ")
            }
          }
          if (errMsg === "") {
            errMsg = "An error occured. Please try again later"
          }
          toast.error(errMsg)
        })
        .finally(() => {
          setLoading(false)
        })
    }
  }

  const fullName = kelas.contact_name
    ? kelas.contact_name
    : user.first_name + " " + user.last_name
  const contactPhone = kelas.contact_phone ? kelas.contact_phone : user.phone

  const warningMessageLst = []
  if (kelas.paket_pembayaran?.length === 0) {
    warningMessageLst.push(
      "Tim Taman Siswa belum membuatkan Anda paket pembayaran"
    )
  }
  if (kelas.paket_pertemuan?.length === 0) {
    warningMessageLst.push(
      "Tim Taman Siswa belum membuatkan Anda paket pertemuan"
    )
  }

  return (
    <MustLoggedInWrapper>
      <div>
        <Modal
          title={
            isEdit
              ? "Kelasmu berhasil diperbaharui"
              : "Kelasmu berhasil didaftarkan!"
          }
          body={
            isEdit
              ? "Perubahan Anda telah disimpan di dalam sistem. Anda bisa melihat hasilnya dengan menekan tombol Lihat Kelas"
              : "Tim kami akan meninjau terlebih dahulu kelas yang telah kamu daftarkan. Kami akan mengirimkan informasi selanjutnya melalui email."
          }
          btnText="OK"
          visible={isSuccess}
          btnClicked={() => setSuccess(false)}
        />
        <ClassStyles className="layout">
          <StyledForm ref={form} onSubmit={submit}>
            <div className="top-class-wrapper">
              <div className="desc-class publish-class">
                {isEdit && (
                  <div style={{ paddingBottom: "24px", textAlign: "center" }}>
                    <Button
                      className="secondary"
                      to={`/kelas/${kelas.slug}/`}
                      type="button"
                    >
                      Lihat Kelas
                    </Button>
                  </div>
                )}
                <div className="publish-btn-wrapper">
                  <h5>Slug:</h5>
                  <input
                    id="slug"
                    name="slug"
                    type="text"
                    placeholder="kelas-menjahit-oleh-bu-tedjo"
                    onChange={controlledKelas("slug")}
                    value={kelas.slug}
                    maxLength={50}
                    required
                  />
                  <Button disabled={loading}>
                    {isEdit ? "UPDATE CLASS" : "PUBLISH CLASS"}
                  </Button>
                </div>
                <Alert>
                  {kelas.slug && !/^[a-z0-9-]+$/.test(kelas.slug) ? (
                    "Slug can only contain a-z, 0-9, or -"
                  ) : (
                    <span>
                      Your class will be available at
                      https://taman-siswa.com/kelas/
                      {kelas.slug ? kelas.slug : "{slug}"}
                    </span>
                  )}
                </Alert>
                <div className="contact-input">
                  <h5>Contact Name:</h5>
                  <input
                    id="contact_name"
                    name="contact_name"
                    type="text"
                    defaultValue={fullName}
                    maxLength={100}
                  />
                </div>
                <div className="contact-input">
                  <h5>Contact Phone:</h5>
                  <input
                    id="contact_phone"
                    name="contact_phone"
                    type="text"
                    defaultValue={contactPhone}
                    maxLength={20}
                  />
                </div>
                {isEdit ? (
                  <div style={{ paddingTop: "20px", textAlign: "center" }}>
                    <h5>
                      Status:{" "}
                      {kelas.is_verified ? (
                        <span style={{ color: "#51b848" }}>
                          Kelas Terverifikasi
                        </span>
                      ) : (
                        <span style={{ color: "#f16ba9" }}>
                          Kelas Belum Diverifikasi
                        </span>
                      )}
                    </h5>
                    {warningMessageLst.length === 0 ? (
                      <></>
                    ) : (
                      <p style={{ paddingTop: "8px" }}>
                        <b>Peringatan:</b> {warningMessageLst.join(", ")}
                      </p>
                    )}
                  </div>
                ) : (
                  <></>
                )}
                <div>
                  <hr />
                </div>
              </div>
              <div className="top-class">
                <div className="class-logo">
                  <ImageFile name="logo" picture={kelas.logo} />
                </div>
                <div className="short-desc">
                  <h1>
                    <input
                      id="name"
                      name="name"
                      type="text"
                      placeholder="Kelas Menjahit oleh Bu Tedjo"
                      defaultValue={kelas.name}
                      maxLength={50}
                      required
                    />
                  </h1>
                  <h5>
                    by{" "}
                    <span style={{ color: "#54b2e5" }}>
                      {user.first_name + " " + user.last_name}
                    </span>
                  </h5>
                  <div>
                    <textarea
                      id="description"
                      name="description"
                      type="text"
                      placeholder="Melalui kelas ini, Kamu akan diperkenalkan teknik-teknik dasar dalam menjahit. Serta tidak lupa sesi julid bersama Bu Tedjo. Sampai jumpa di kelas!"
                      rows="5"
                      defaultValue={kelas.description}
                      required
                    />
                  </div>
                  <div className="tags">
                    <h5>Tags:</h5>
                    <input
                      id="tags"
                      name="tags"
                      type="text"
                      placeholder="matematika, fisika, sbmptn"
                      defaultValue={kelas.tags?.join(", ")}
                    />
                    <h5>Tipe Kelas:</h5>
                    <Select id="type" name="type" disabled={isEdit}>
                      {typeKelasList.map(({ name, value }, index) => (
                        <option
                          value={value}
                          key={index}
                          selected={kelas.type === value}
                        >
                          {name}
                        </option>
                      ))}
                    </Select>
                  </div>
                </div>
              </div>
            </div>
            <div className="desc-class">
              <div className="desc-class-left">
                <div className="small-nav">
                  <div
                    style={
                      smallnav === "tentang-kelas"
                        ? {
                            fontWeight: "bold",
                            borderBottom: "4px solid #51B848",
                          }
                        : {}
                    }
                    onClick={() => setSmallnav("tentang-kelas")}
                  >
                    Tentang
                  </div>
                  <div
                    style={
                      smallnav === "pengajar"
                        ? {
                            fontWeight: "bold",
                            borderBottom: "4px solid #51B848",
                          }
                        : {}
                    }
                    onClick={() => setSmallnav("pengajar")}
                  >
                    Pengajar
                  </div>
                  <div
                    style={
                      smallnav === "jadwal"
                        ? {
                            fontWeight: "bold",
                            borderBottom: "4px solid #51B848",
                          }
                        : {}
                    }
                    onClick={() => setSmallnav("jadwal")}
                  >
                    Jadwal
                  </div>
                  {!isEdit || kelas.type === "TP" ? (
                    <div
                      style={
                        smallnav === "tamanscout"
                          ? {
                              fontWeight: "bold",
                              borderBottom: "4px solid #51B848",
                            }
                          : {}
                      }
                      onClick={() => setSmallnav("tamanscout")}
                    >
                      TamanScout
                    </div>
                  ) : (
                    <></>
                  )}
                </div>
                <div className="all-desc-here">
                  <div
                    style={
                      smallnav !== "tentang-kelas" ? { display: "none" } : {}
                    }
                    className="tentang-kelas"
                  >
                    <h5 style={{ marginBottom: "0" }}>Poster</h5>
                    <div className="poster-photo">
                      <svg viewBox="0 0 1 1"></svg>
                      <div>
                        <ImageFile name="poster" picture={kelas.poster} />
                      </div>
                    </div>

                    <h5 style={{ paddingTop: "32px" }}>Overview</h5>
                    <p>
                      <InputDraft
                        name="overview"
                        placeholder="Deskripsi lengkap kelas"
                        defaultValue={kelas.overview}
                      />
                    </p>

                    <h5>Silabus</h5>
                    <p>
                      <InputDraft
                        name="syllabus"
                        placeholder="Silabus dari kelas ini akan berisi:&#10;- Teori menjahit Newton&#10;- Latihan menjulid khas Bu Tedjo"
                        defaultValue={kelas.syllabus}
                      />
                    </p>

                    <h5>Program</h5>
                    <p>
                      <InputDraft
                        name="program"
                        placeholder="Program dari kelas yang dibuat."
                        defaultValue={kelas.program}
                      />
                    </p>

                    <h5>Harapan Pembelajaran</h5>
                    <p>
                      <InputDraft
                        name="objective"
                        placeholder="Diharapkan setelah mengikuti kelas ini peserta dapat menjahit"
                        defaultValue={kelas.objective}
                      />
                    </p>

                    <h5>Link Silabus</h5>
                    <p>
                      <input
                        id="syllabus_link"
                        name="syllabus_link"
                        type="text"
                        placeholder="Awali link dengan https:// "
                        defaultValue={kelas.syllabus_link}
                        maxLength={200}
                      />
                    </p>
                  </div>

                  <div
                    style={smallnav !== "pengajar" ? { display: "none" } : {}}
                    className="pengajar"
                  >
                    <InvitePengajar
                      kelas={kelas}
                      updateKelas={updateKelas}
                      isEdit={isEdit}
                    />
                  </div>

                  <div
                    style={smallnav !== "jadwal" ? { display: "none" } : {}}
                    className="jadwal"
                  >
                    <JadwalMaker
                      kelas={kelas}
                      updateKelas={updateKelas}
                      isEdit={isEdit}
                    />
                  </div>

                  <div
                    style={smallnav !== "tamanscout" ? { display: "none" } : {}}
                    className="tentang-kelas"
                  >
                    {isEdit ? (
                      <p>
                        <InputDraft
                          name="tamanscout"
                          placeholder="Daftar beasiswa TamanScout dengan mengisi form berikut: bit.ly/ContohForm"
                          defaultValue={kelas.tamanscout}
                        />
                      </p>
                    ) : (
                      <div>
                        TamanScout (only for TamanClass+) available after you
                        published the class
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className="desc-class-right">
                <div className="tempat-tgl" style={{ paddingTop: "20px" }}>
                  <label>Tanggal mulai kelas:</label>
                  <input
                    id="timeline_start"
                    name="timeline_start"
                    type="date"
                    onChange={controlledKelas("timeline_start")}
                    value={kelas.timeline_start}
                  />
                  <label style={{ paddingTop: "12px" }}>
                    Tanggal selesai kelas:
                  </label>
                  <input
                    id="timeline_end"
                    name="timeline_end"
                    type="date"
                    onChange={controlledKelas("timeline_end")}
                    value={kelas.timeline_end}
                  />
                </div>
                <div className="tempat-tgl">
                  <label>Kota:</label>
                  <SelectKota
                    id="city"
                    name="city"
                    defaultChecked={kelas.city?.id}
                  />
                </div>
                <div className="tutup-pendaftaran">
                  Tutup Pendaftaran:
                  <br />
                  <input
                    id="registration_due"
                    name="registration_due"
                    type="date"
                    onChange={controlledKelas("registration_due")}
                    value={kelas.registration_due}
                  />
                </div>
                <hr />
                <div className="narahubung">Narahubung</div>
                <div>Mata</div>
                <div>+6285174224473</div>
              </div>
            </div>
          </StyledForm>
        </ClassStyles>
      </div>
    </MustLoggedInWrapper>
  )
}

export default withConnect(CreateClass)
